import axios from 'axios';
import {baseURL} from './const';

const api = axios.create({
    baseURL: baseURL,
    headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
    }
});

api.interceptors.response.use(response => {
    return response;
}, error => {
    console.log(error);
    return error;
});

export {
    api
}